module.exports = __webpack_public_path__ + "step4.b857f60b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/step4.jpg
// module id = pgMy
// module chunks = 0